"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var playkit_js_1 = require("@playkit-js/playkit-js");
var image_player_1 = require("./image-player");
(0, playkit_js_1.registerEngine)(image_player_1.ImagePlayer.id, image_player_1.ImagePlayer);
